import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  position: ${({ cover }) => (cover ? 'absolute' : 'relative')};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ cover, size }) => (cover ? '100%' : `${size}px`)};
  height: ${({ cover, size }) => (cover ? '100%' : `${size}px`)};
  margin: 0 auto;

  ${({ cover }) => {
    if (cover) {
      return `
      top: 0;
      left: 0;
    `;
    }
    return null;
  }}
`;

const Cover = styled.div`
  position: absolute;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
`;

const Icon = styled.img`
  display: block;
  position: relative;
  z-index: 2;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
`;

const Loader = ({ cover, size }) => (
  <Wrapper cover={cover} size={size}>
    <Icon src="/images/icons/loading.svg" alt="loading" size={size} />
    {cover ? <Cover /> : null}
  </Wrapper>
);

Loader.defaultProps = {
  cover: false,
  size: 60,
};

Loader.propTypes = {
  cover: PropTypes.bool,
  size: PropTypes.number,
};

export default Loader;
